import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    periods: [],
    selectedPeriodIndex: 0,
    selectedCategoryIndex: null,
    nextElementId: 1
};

const periodslice = createSlice({
    name: 'period',
    initialState,
    reducers: {
        selectPeriod: (state, action) => {
            state.selectedPeriodIndex = action.payload;
            state.selectedCategoryIndex = null;
        },
        selectCategory: (state, action) => {
            state.selectedCategoryIndex =
                state.selectedCategoryIndex === action.payload ? null : action.payload;
        },
        addElement: (state, action) => {
            const { periodIndex, categoryIndex, element } = action.payload;
            console.log("selectedCategoryIndex.........", periodIndex);
            console.log("selectedCategoryIndex.........", categoryIndex);
            console.log("action.payload.........", action.payload);
            if (state.periods[periodIndex]?.categories[categoryIndex]) {
                const newUiKey = state.nextElementId++;
                const newElement = {
                    ...element,
                    id: "0",
                    uiKey: newUiKey,
                    name: element.name || `New Element ${state.periods[periodIndex].categories[categoryIndex].elementlist.length + 1}`,
                    quantity: element.quantity,
                    rate: element.rate,
                    grossvalue: element.grossvalue,
                    period: element.period,
                    element: element.element,
                    cost_period: element.cost_period,
                    element_remarks: element.element_remarks,
                    quantity: element.quantity,
                    cost_maintenance: element.cost_maintenance,
                    wi_rate: element.wi_rate,
                    cost_margin: element.cost_margin,
                    cost_escalation_percentage: element.cost_escalation_percentage,
                    cost_escalation: element.cost_escalation,
                    margin_rate_percentage: element.margin_rate_percentage,
                    cost_with_buffer_month: element.cost_with_buffer_month,
                    capex_maintenance: element.capex_maintenance,
                    cost_buffer: element.cost_buffer,
                    basic_cost_value: element.basic_cost_value,
                    cost_without_buffer_month: element.cost_without_buffer_month,
                    buffer_rate: element.buffer_rate,
                    gross_value: element.gross_value,
                    capex_cost_interest: element.capex_cost_interest,
                    cost_with_buffer_period: element.cost_with_buffer_period,
                    rate: element.rate,
                    capex_interest_rate_percentage: element.capex_interest_rate_percentage,
                    cost_insurance: element.cost_insurance,
                    cost_without_buffer_period: element.cost_without_buffer_period,
                    capex_insurance_percentage: element.capex_insurance_percentage,
                    cost_wi: element.cost_wi

                };
                state.periods[periodIndex].categories[categoryIndex].elementlist.push(newElement);
            }

        },
        updateElement: (state, action) => {
            const { periodIndex, categoryIndex, elementIndex, element } = action.payload;

            console.log("🔁 updateElement called with:", {
                periodIndex,
                categoryIndex,
                elementIndex,
                element,
            });

            // Validate all indices exist
            if (
                periodIndex === undefined ||
                categoryIndex === undefined ||
                elementIndex === undefined ||
                !state.periods[periodIndex] ||
                !state.periods[periodIndex].categories[categoryIndex] ||
                !state.periods[periodIndex].categories[categoryIndex].elementlist
            ) {
                console.error("❌ Invalid update indices:", {
                    periodIndex,
                    categoryIndex,
                    elementIndex,
                    periodsLength: state.periods.length,
                    periodObject: state.periods[periodIndex],
                    categoriesLength: state.periods[periodIndex]?.categories?.length,
                    categoryObject: state.periods[periodIndex]?.categories[categoryIndex],
                    elementlistLength:
                        state.periods[periodIndex]?.categories[categoryIndex]?.elementlist?.length,
                });
                return;
            }

            const oldElement = state.periods[periodIndex].categories[categoryIndex].elementlist[elementIndex];
            console.log("📦 Replacing old element:", oldElement);
            console.log("🆕 With new element:", element);

            // Create a new array to ensure immutability
            const updatedElementlist = [
                ...state.periods[periodIndex].categories[categoryIndex].elementlist,
            ];
            updatedElementlist[elementIndex] = element;

            // Update the state immutably
            state.periods[periodIndex].categories[categoryIndex].elementlist = updatedElementlist;

            console.log("✅ Elementlist after update:", updatedElementlist);
        },

        deleteElement: (state, action) => {
            const { periodIndex, categoryIndex, elementIndex } = action.payload;
            if (state.periods[periodIndex]?.categories[categoryIndex]) {
                state.periods[periodIndex].categories[categoryIndex].elementlist.splice(elementIndex, 1);
            }
        },
        setPeriods: (state, action) => {
            state.periods = action.payload.map(period => ({
                ...period,
                categories: period.categories.map(category => ({
                    ...category,
                    elementlist: Array.isArray(category.elementlist) ? [...category.elementlist] : [] // Ensure array
                }))
            }));
            state.selectedPeriodIndex = 0;
            state.selectedCategoryIndex = null;
        },
        updatePeriods: (state, action) => {
            state.periods = action.payload.map(period => ({
                ...period,
                categories: period.categories.map(category => ({
                    ...category,
                    elementlist: Array.isArray(category.elementlist) ? [...category.elementlist] : []
                }))
            }));
        },
        resetPeriods: (state) => {
            state.periods = [];
            state.selectedPeriodIndex = 0;
            state.selectedCategoryIndex = null;
        },
        pasteCategoryElements: (state, action) => {
            const { periodIndex, categoryIndex, elements } = action.payload;
            if (state.periods[periodIndex]?.categories[categoryIndex] && Array.isArray(elements)) {
                const newElements = elements.map(el => ({
                    ...el,
                    id: "0",
                    uiKey: state.nextElementId++
                }));
                state.periods[periodIndex].categories[categoryIndex].elementlist = [
                    ...state.periods[periodIndex].categories[categoryIndex].elementlist,
                    ...newElements
                ];
            }
        },
    }
});

export const {
    selectPeriod,
    selectCategory,
    addElement,
    updateElement,
    deleteElement,
    setPeriods,
    updatePeriods,
    resetPeriods,
    pasteCategoryElements
} = periodslice.actions;

export default periodslice.reducer;